import React from "react";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { TextCard } from "@radarly/models/cards/model";
import Tile from "@radarly/shared/cards/tile";
import Text from "@radarly/shared/widgets/text";
import { CardProps } from "../model";

const PADDING_BOTTOM = 24;

const RadarlyTextCard = ({ card, height }: CardProps<TextCard>) => {
  const locale = useCurrentUserLocale();
  const dataviz = card.dataviz;
  return (
    <Tile title={card.title} height={height}>
      <Text
        dataviz={dataviz}
        height={height - PADDING_BOTTOM}
        locale={locale}
      />
    </Tile>
  );
};

export default RadarlyTextCard;
